module.exports = __webpack_public_path__ + "img/checkmark.0957ae41.svg";